import { motion } from 'framer-motion';
import { PARTNERS } from './data';

// ABOUT — long-form studio essay + the two partners as named ledger entries.
export default function About() {
  return (
    <div className="bg-[#DADCD6] text-[#1B1A18]">
      <section className="pt-12 pb-10 max-w-[1500px] mx-auto px-6 lg:px-12 border-b border-[#1E3A5F]/15">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#1E3A5F] mb-4">/ Index 03 · Studio</p>
        <h1 className="font-serif text-[44px] sm:text-[72px] lg:text-[112px] leading-[0.92] tracking-[-0.025em] text-[#1E3A5F]">A practice held by <span className="italic">two</span>.</h1>
      </section>

      <article className="max-w-[1100px] mx-auto px-6 lg:px-12 py-20 grid lg:grid-cols-[1fr_2fr] gap-12 lg:gap-20">
        <div className="lg:sticky lg:top-32 self-start">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#1E3A5F]">/ The studio</p>
          <p className="font-mono text-[11px] text-[#1B1A18]/55 mt-3 leading-relaxed">An essay on the practice. Lina and Edmund, founding partners, jointly authored.</p>
        </div>
        <div className="font-serif text-lg lg:text-xl text-[#1B1A18]/85 leading-[1.7] space-y-6">
          <p className="first-letter:font-serif first-letter:text-7xl first-letter:float-left first-letter:mr-3 first-letter:mt-1 first-letter:leading-[0.85] first-letter:text-[#1E3A5F]">When we founded Hadid & Vance in 2003 we did not set out to be a famous practice. We set out to be a careful one. The work has occasionally been published; it has more often not. We are not, on the whole, sorry about either.</p>
          <p>Our staff is twenty-six. Our project list is short. We refuse approximately three projects for every one we accept, almost always for the same reason: we cannot see how to give it the time it asks for.</p>
          <blockquote className="border-l-4 border-[#E5C61F] pl-6 py-2 my-10">
            <p className="italic text-2xl lg:text-3xl leading-[1.3] text-[#1E3A5F]">&ldquo;Architecture takes the time it takes. Six fewer drawings will produce six fewer satisfactions, and we have noticed.&rdquo;</p>
          </blockquote>
          <p>The fee structures we use have not materially changed since the studio was founded. The drawing standard has not either. We were Pritzker-shortlisted twice; the day after the second one we were drawing a stair detail for a forty-square-metre cabin.</p>
        </div>
      </article>

      {/* Partners ledger */}
      <section className="bg-[#1E3A5F] text-[#DADCD6] py-20">
        <div className="max-w-[1300px] mx-auto px-6 lg:px-12">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#E5C61F] mb-4">/ Partners</p>
          <div className="grid md:grid-cols-2 gap-px bg-white/15">
            {PARTNERS.map((p, i) => (
              <motion.div key={p.n} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
                className="bg-[#1E3A5F] p-10 lg:p-14">
                <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#E5C61F] mb-3">/ Partner 0{i + 1}</p>
                <h2 className="font-serif text-4xl lg:text-5xl">{p.n}</h2>
                <p className="font-serif italic text-base text-white/65 mt-2">{p.r}</p>
                <p className="text-base text-white/80 mt-6 leading-[1.7] max-w-md">{p.bio}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
